export default __webpack_public_path__ + "static/media/no-users.5a7aa5f8.svg";